import { trackCTA } from '../utils/analytics'

/**
 * A CTA button/link that automatically tracks clicks to Google Analytics
 */
export default function TrackedCTA({
  href,
  children,
  location = 'unknown',
  ctaName,
  className = '',
  ...props
}) {
  const handleClick = (e) => {
    const name = ctaName || (typeof children === 'string' ? children : 'CTA')
    trackCTA(name, location)

    // If there's a custom onClick, call it
    if (props.onClick) {
      props.onClick(e)
    }
  }

  return (
    <a
      href={href}
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  )
}
